import React from 'react'

import PropTypes from 'prop-types'
import classNames from 'classnames'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import InputLabel from '@material-ui/core/InputLabel'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import FormControl from '@material-ui/core/FormControl'
import ExpandMore from '@material-ui/icons/ExpandMore'

import SubmitButton from 'components/atoms/buttons/SubmitButton'

export const styles = theme => ({
  root: {
    width: 400,
    minHeight: 320,
    textAlign: 'center',
    padding: `0 ${theme.spacing(1)}px`,
  },
  errorMessage: {
    padding: `${theme.spacing(2)}px 0`,
  },
  title: {
    marginBottom: theme.spacing(4),
  },
  form: {
    width: 222,
    margin: '0 auto',
    textAlign: 'initial',
    marginTop: theme.spacing(6),
  },
  formControl: {
    width: '100%',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  formControlButton: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(1),
  },
  icon: {
    top: 0,
    right: 0,
    position: 'absolute',
    pointerEvents: 'none',
  },
  menuItem: {
    textTransform: 'none',
  },
})

const OrganisationCodeForm = ({
  values,
  classes,
  isSubmitting,
  handleFormSubmit,
  handleFieldChange,
  className: classNameProp,
}) => {
  const className = classNames(classes.root, classNameProp)
  return (
    <div className={className}>
      <Typography variant="h1" className={classes.title}>
        Create a new invite code
      </Typography>
      <Typography>
        Share an invite code with Goodnature Chirp App users and then approve
        them here so they can share traps with you and help maintain them.
      </Typography>
      <form
        className={classes.form}
        noValidate
        autoComplete="off"
        onSubmit={handleFormSubmit}>
        <FormControl className={classes.formControl}>
          <InputLabel htmlFor="expiry-date">Code expiry</InputLabel>
          <Select
            value={values.expiryDate}
            onChange={handleFieldChange}
            IconComponent={() => (
              <ExpandMore className={classes.icon} color="primary" />
            )}
            inputProps={{
              name: 'expiryDate',
              id: 'expiry-date',
            }}>
            <MenuItem className={classes.menuItem} value={7}>
              One week
            </MenuItem>
            <MenuItem className={classes.menuItem} value={30}>
              One month
            </MenuItem>
            <MenuItem className={classes.menuItem} value={0}>
              Never
            </MenuItem>
          </Select>
        </FormControl>
        <FormControl className={classes.formControlButton} fullWidth>
          <SubmitButton
            autoFocus
            size="medium"
            type="submit"
            color="primary"
            variant="primary"
            disabled={isSubmitting}>
            Create code
          </SubmitButton>
        </FormControl>
      </form>
    </div>
  )
}

OrganisationCodeForm.propTypes = {
  errors: PropTypes.object,
  values: PropTypes.any,
  classes: PropTypes.object,
  actions: PropTypes.object,
  className: PropTypes.string,
  codeExpiry: PropTypes.number,
  isSubmitting: PropTypes.bool,
  handleFormSubmit: PropTypes.func,
  handleFieldChange: PropTypes.func,
}

OrganisationCodeForm.defaultProps = {}

export default withStyles(styles)(OrganisationCodeForm)



// WEBPACK FOOTER //
// ./src/components/organisms/OrganisationCodeForm/OrganisationCodeForm.js